import type { HTMLAttributes, PropsWithChildren } from 'react'

export default function TextInputError({
  children,
  ...rest
}: Readonly<PropsWithChildren<HTMLAttributes<HTMLParagraphElement>>>) {
  return (
    <p className="font-semibold mt-s text-red-600" {...rest}>
      {children}
    </p>
  )
}
